import { Button } from '@/components/Button';
import { Card } from '@/components/Card';
import { Text } from '@/components/Text';
import { t } from 'i18next';
import { FaCalendarAlt, FaExchangeAlt, FaUsers } from 'react-icons/fa';

export const CreateEventCallToAction = () => {
  return (
    <Card className="bg-gradient-to-r from-primary/10 to-linko-light/10 p-6">
      <div className="flex flex-col items-center gap-6 text-center">
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-2xl font-bold text-secondary">
            {t('listEvents:create_cta.title')}
          </h2>
          <Text className="text-sm">
            {t('listEvents:create_cta.description')}
          </Text>
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          <div className="flex flex-col items-center gap-2">
            <div className="rounded-full bg-linko-light/20 p-3">
              <FaCalendarAlt className="text-2xl text-linko-light" />
            </div>
            <h3 className="font-semibold">
              {t('listEvents:create_cta.planning.title')}
            </h3>
            <Text className="text-sm">
              {t('listEvents:create_cta.planning.description')}
            </Text>
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="rounded-full bg-linko-light/20 p-3">
              <FaExchangeAlt className="text-2xl text-linko-light" />
            </div>
            <h3 className="font-semibold">
              {t('listEvents:create_cta.exchange.title')}
            </h3>
            <Text className="text-sm">
              {t('listEvents:create_cta.exchange.description')}
            </Text>
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="rounded-full bg-linko-light/20 p-3">
              <FaUsers className="text-2xl text-linko-light" />
            </div>
            <h3 className="font-semibold">
              {t('listEvents:create_cta.followup.title')}
            </h3>
            <Text className="text-sm">
              {t('listEvents:create_cta.followup.description')}
            </Text>
          </div>
        </div>
        <Button
          onClick={() => {
            window.open('https://linko-connect.com/contact/', '_blank');
          }}
          className="flex items-center gap-2"
        >
          {t('listEvents:create_cta.contact_us')}
        </Button>
      </div>
    </Card>
  );
};
